<template>
  <v-container>
    <v-row class="text-center">
      <v-col>
        <h1 class="display-2 font-weight-bold mb-3">
          {{ $t('header.welcome') }}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <ini-form/>
      </v-col>
      <v-col cols="12" md="6">
        <task-list/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IniForm from '@/components/IniForm'
import TaskList from '@/components/TaskList'

export default {
  name: 'Broker',
  components: {
    IniForm,
    TaskList
  },

  data: () => ({
  })
}
</script>
